import type { APIHomeSection } from '~/api/commonApi'
import type { THomeSection, THomeSectionDiamondHistory } from '~/layers/homepage/data/types'
import type { TRemotePicture } from '~/types/media.types'

import { log } from '~/layers/homepage/data/logger'
import { THomeSectionType } from '~/layers/homepage/data/types'

export const make = (
  apiSection: APIHomeSection,
  _index: number,
): TNullable<THomeSectionDiamondHistory & THomeSection> => {
  if (Array.isArray(apiSection.images)) {
    log(`Изображение блока ID ${apiSection.id} не установлено. Пропуск`, apiSection)
    return null
  }

  return {
    type: THomeSectionType.DiamondHistory,
    picture: apiSection.images as TRemotePicture,
    navigation: {
      title: apiSection.title,
      icon: apiSection.icon,
      buttonText: apiSection.buttonText,
      buttonLink: apiSection.link,
    },
  }
}
